import { humanizeLargeNumber } from 'utils'

export const chartOptions = {
  grid: {
    padding: {
      left: 5,
      right: 5,
      top: 5,
      bottom: 5,
    },
  },
  chart: {
    animations: {
      enabled: false,
    },
    sparkline: {
      enabled: true,
    },
  },
  yaxis: {
    forceNiceScale: true,
    floating: true,
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    labels: {
      show: false,
    },
    min: 0,
  },
  tooltip: {
    fixed: {
      enabled: true,
      position: 'bottomRight',
      offsetX: 80,
      offsetY: 20,
    },
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return `<div class="tooltip-relevance-index">
                <span>
                  ${w.globals.categoryLabels[dataPointIndex]} :
                  ${humanizeLargeNumber(series[seriesIndex][dataPointIndex])}
                </span>
              </div>`
    },
    marker: {
      show: false,
    },
  },
  markers: {
    size: 0,
    show: false,
  },
  stroke: {
    width: 2,
    curve: 'straight',
    lineCap: 'butt',
  },
}
